import React from 'react';
import PropTypes from 'prop-types';

export default class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: this.props.isVisible,
    };

    this.closeBtn = null;
    if (this.props.isCloseable) {
      this.closeBtn = (
        <button
          onClick={this.props.buttonClick}
          style={{
            border: 'none',
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'center',
            padding: 0,
            fontSize: this.props.fontSize,
            color: this.props.buttonColor,
          }}
        >x
        </button>
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isVisible !== nextProps.isVisible) {
      this.setState({ isVisible: nextProps.isVisible });
    }
  }

  render() {
    if (!this.state.isVisible) {
      return null;
    }

    return (
      <div
        className={this.props.className}
        style={Object.assign({}, this.props.style, { width: '100%' })}
      >
        { this.props.children }
        { this.closeBtn }
      </div>
    );
  }
}

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  isCloseable: PropTypes.bool,
  buttonClick: PropTypes.func,
  fontSize: PropTypes.number,
  buttonColor: PropTypes.string,
  style: PropTypes.shape(),
};

Banner.defaultProps = {
  className: '',
  isVisible: true,
  isCloseable: true,
  buttonClick: null,
  fontSize: 14,
  buttonColor: '#000',
  style: null,
};



// WEBPACK FOOTER //
// ./src-react/Banner/index.jsx